// src/provider/useGoogleMaps.js
import { useContext } from "react";
import { GoogleMapsContext } from "./GoogleMapsProvider";

export default function useGoogleMaps() {
  return useContext(GoogleMapsContext);
}
